import React from "react";
import { useNavigate } from "react-router-dom";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Tooltip,
  Legend,
  XAxis,
  YAxis,
  CartesianGrid,
  Cell,
} from "recharts";
import "../styles/Analytics.css";

const Analytics = () => {
  const navigate = useNavigate();

  // === Dummy Data (replace with backend API later) ===
  const performanceTrend = [
    { exam: "WBJEE", score: 78 },
    { exam: "JEE Main", score: 85 },
    { exam: "JEE Advanced", score: 90 },
  ];

  const subjectWise = [
    { subject: "Math", score: 90 },
    { subject: "Physics", score: 82 },
    { subject: "Chemistry", score: 75 },
  ];

  const subjectDistribution = [
    { name: "Math", value: 90 },
    { name: "Physics", value: 82 },
    { name: "Chemistry", value: 75 },
  ];

  const COLORS = ["#ff4d4f", "#1677ff", "#52c41a"];

  return (
    <div className="analytics-container">
      <h1>📈 Detailed Analytics</h1>
      <p className="analytics-subtitle">
        Visual insights into your exam performance — track growth, compare subjects, and identify strengths.
      </p>

      <div className="analytics-charts-grid">
        {/* 📊 Trend Line Chart */}
        <div className="analytics-card">
          <h3>Overall Performance Trend</h3>
          <LineChart width={400} height={250} data={performanceTrend}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="exam" />
            <YAxis domain={[0, 100]} />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="score"
              stroke="#1677ff"
              strokeWidth={3}
              dot={{ r: 5 }}
            />
          </LineChart>
        </div>

        {/* 📚 Subject-wise Bar Chart */}
        <div className="analytics-card">
          <h3>Subject-Wise Scores</h3>
          <BarChart width={400} height={250} data={subjectWise}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="subject" />
            <YAxis domain={[0, 100]} />
            <Tooltip />
            <Bar dataKey="score" fill="#ff4d4f" />
          </BarChart>
        </div>

        {/* 🥧 Subject Distribution */}
        <div className="analytics-card">
          <h3>Subject Performance Distribution</h3>
          <PieChart width={400} height={250}>
            <Pie
              data={subjectDistribution}
              cx="50%"
              cy="50%"
              outerRadius={80}
              label
              dataKey="value"
            >
              {subjectDistribution.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </div>
      </div>

      <div className="analytics-actions">
        <button className="back-button" onClick={() => navigate("/dashboard")}>
          ⬅️ Back to Dashboard
        </button>
      </div>
    </div>
  );
};

export default Analytics;
